import React from 'react';
import {
  Checkbox,
  Form,
  GridColumn,
  GridRow,
  Layout,
  ParagraphHeader,
} from '@axiom/ui';

import { ContactStore } from '../../stores/contact-store';
import { ContactsLegacyApi } from '../../api/contacts-legacy-api';

import type {
  ManageContactFormEmailPrefType,
  ManageContactFormType,
} from './manage-contact-form-email-pref-schema';
import { ManageContactFormSchema } from './manage-contact-form-email-pref-schema';

export const ManageContactFormEmailPref = (
  props: ManageContactFormEmailPrefType
) => {
  const { contactId, accountEmailOptOut, ...initValue } = props;
  const handleOnSubmit = async (changeData: ManageContactFormType) => {
    const payload: {
      availabilityNotificationOptOut?: boolean;
      benchNotificationOptOut?: boolean;
    } = {
      availabilityNotificationOptOut: undefined,
      benchNotificationOptOut: undefined,
    };

    if (changeData.availabilityNotificationOptOut !== undefined) {
      payload.availabilityNotificationOptOut =
        !changeData.availabilityNotificationOptOut;
    }

    if (changeData.benchNotificationOptOut !== undefined) {
      payload.benchNotificationOptOut = !changeData.benchNotificationOptOut;
    }

    if (contactId) {
      await ContactsLegacyApi.updateContacts(contactId, payload);
    }

    return ContactStore.load(contactId);
  };

  return (
    <GridRow gutterBottom="24px">
      <GridColumn width={5}>
        <ParagraphHeader name="SECTION_HEADER">
          User Email Notification Preferences
        </ParagraphHeader>
      </GridColumn>
      <GridColumn width={7} data-test="EMAIL_PREF">
        <Form
          schema={ManageContactFormSchema}
          name="EMAIL_PREF_FORM"
          initialValues={initValue}
          onSubmit={handleOnSubmit}
          submitOnChange
        >
          {() => (
            <Layout verticalGutter="24px" direction="vertical">
              <Checkbox
                name="benchNotificationOptOut"
                description="Bench Updates"
                displayValue="Let me know when there are additions or changes to talent on my bench."
                disabled={accountEmailOptOut.BenchUpdates}
              />
              <Checkbox
                name="availabilityNotificationOptOut"
                description="Availability Updates"
                displayValue="Let me know when availability changes for talent on my bench."
                disabled={accountEmailOptOut.AvailabilityUpdates}
              />
            </Layout>
          )}
        </Form>
      </GridColumn>
    </GridRow>
  );
};
